import { render, staticRenderFns } from "./settingsUpload.vue?vue&type=template&id=b763b20c&scoped=true&"
import script from "./settingsUpload.vue?vue&type=script&lang=js&"
export * from "./settingsUpload.vue?vue&type=script&lang=js&"
import style0 from "./settingsUpload.vue?vue&type=style&index=0&id=b763b20c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b763b20c",
  null
  
)

export default component.exports